import { AppDispatch } from "@Reducers/index";
import { getBackendUrl } from "@Utils";
import axiosWrapper from "@Services/axiosWrapper";
import { deleteIssuesData } from "./issues";
import { showToastNotification } from "@Reducers/toastSlice";
import { SOMETHING_WENT_WRONG, TOAST_TYPE_ERROR, TOAST_TYPE_SUCCESS } from "@Services/constants";
import { t } from "@i18n";
import { errorCodes } from "@Helpers/errorCodes";
import type { DeleteIssuesDataRequest, DeleteIssuesDataResponse } from "@ServerTypes/issues/issues.schema.js";
import type { ObjectIdString } from "@Helpers/schemas/common.schema";

const deleteErrorContent = (errorCode: number | undefined) => {
  switch (errorCode) {
    case errorCodes.ISSUE_DELETE_BLOCKED_BY_REVIEW:
      return t("Some Issue(s) could not be deleted as they are added to Reviews.");
    case errorCodes.ISSUE_NO_ACCESS:
      return t("You do not have permission to delete this issue.");
    case errorCodes.ISSUE_NOT_FOUND:
      return t("Issue not found.");
    default:
      return SOMETHING_WENT_WRONG;
  }
};

export function deleteIssueData(id: ObjectIdString[]) {
  return async (dispatch: AppDispatch): Promise<boolean> => {
    const data: DeleteIssuesDataRequest = { id };
    const response = await axiosWrapper.post<DeleteIssuesDataResponse>(
      `${getBackendUrl()}/issues/deleteIssuesData`,
      data,
    );
    if (response.data.status) {
      dispatch(deleteIssuesData(id));
      dispatch(
        showToastNotification({
          content: t("Issue(s) has been successfully deleted."),
          type: TOAST_TYPE_SUCCESS,
        }),
      );
      return true;
    }
    dispatch(
      showToastNotification({
        content: deleteErrorContent(response.data?.errorCode),
        type: TOAST_TYPE_ERROR,
      }),
    );
    return false;
  };
}
